import { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Button, Typography } from "@mui/material";
import {
  ADD_BOOTH_OR_GATE,
  GET_ALL_BOOTH_OR_GATE,
  GET_BOOTH_OR_GATE_BY_ID,
  GATE_MASTER_INACTIVE,
  GATE_MASTER_ACTIVE,
  GET_AREA_BY_ID,
  ADD_EDIT_AREA_MASTER,
  ACTIVE_AREA_MASTER,
  INACTIVE_AREA_MASTER,
} from "../../../services/apiUrls";
import { get, post, Put } from "../../../services/service";
import axios from "axios";
import useIsEqual from "./useIsEqual";
import toast from "react-hot-toast";

const INITIAL_FORM_STATE = {
  id: "",
  name: "",
  description: "",
  locationId: localStorage.getItem("locationId"),
  tenantId: localStorage.getItem("tenantId"),
};

export function useAreaMaster() {
  let locationId = localStorage.getItem("locationId");
  let tenantId = localStorage.getItem("tenantId");

  const [open, setOpen] = useState(false);

  const [search, setSearch] = useState("");

  const [loading, setLoading] = useState(true);

  const [areas, setAreas] = useState([]);

  const [errorMessage, setErrorMessage] = useState("");

  const [formValues, setFormValues] = useState(INITIAL_FORM_STATE);

  const { isEqual, isSpace } = useIsEqual();

  const columns = [
    {
      field: "No.",
      headerName: "NO.",
      width: 65,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "name",
      headerName: "AREA NAME",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "description",
      headerName: "DESCRIPTION",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "deleted",
      headerName: "STATUS",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Box>
            <Button>
              {params?.row?.deleted === false ? (
                <Button
                  variant="contained"
                  size="small"
                  color="success"
                  sx={{ width: "2rem" }}
                  onClick={() => {
                    // setStatusUpdateConfirmPopUp(true);
                    statusInactive(params.row.id);
                  }}
                >
                  <Typography sx={{ fontSize: "10px" }}>Active</Typography>
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  color="error"
                  sx={{ width: "2rem" }}
                  onClick={() => {
                    // setStatusUpdateConfirmPopUp(true);
                    statusActive(params.row.id);
                  }}
                >
                  <Typography sx={{ fontSize: "10px" }}>Inactive</Typography>
                </Button>
              )}
            </Button>
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "ACTION",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <EditIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setOpen(true);
              window.scrollTo(0, 0);
              getAreaById(params.id);
            }}
          />
        );
      },
    },
  ];

  const handleInputChange = (e) => {
    setErrorMessage("");
    let convertedValue = isSpace(e.target.value);
    setFormValues({ ...formValues, [e.target.name]: convertedValue });
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const rows = areas.filter(
    (item) =>
      item?.description?.toLowerCase().includes(search.toLowerCase()) ||
      item?.name?.toLowerCase().includes(search.toLowerCase())
  );

  const isDisabled = formValues.name !== "" && formValues.description !== "";

  const handleClose = () => {
    setOpen(false);
    handleClear();
  };

  const handleOpenForm = () => {
    setOpen(true);
    handleClear();
    setErrorMessage("");
  };

  const handleClear = () => {
    setFormValues(INITIAL_FORM_STATE);
  };

  const getAreas = async () => {
    setLoading(true);
    const url = `${ADD_EDIT_AREA_MASTER.replace(
      "{locationId}",
      locationId
    ).replace("{tenantId}", tenantId)}`;
    try {
      const resp = await get(url);
      if (resp && resp?.id !== "") {
        setLoading(false);
        setAreas(resp);
      }
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getAreaById = async (id) => {
    handleClear();
    const url = `${GET_AREA_BY_ID.replace("{locationId}", locationId)
      .replace("{tenantId}", tenantId)
      .replace("{id}", id)}`;
    const resp = await get(url);
    if (resp && resp.id) {
      setFormValues({
        ...formValues,
        id: resp?.id,
        name: resp?.name,
        description: resp?.description,
      });
    }
  };

  // const findDuplicateArea = () => {
  //   const isDupliacte = areas?.map((area) => {
  //     let isEqualArea = isEqual(area?.name, formValues.name);
  //     let isEqualAreaType = isEqual(area?.areaType, formValues.areaType);
  //     return isEqualArea && isEqualAreaType;
  //   });
  //   let finalResult = isDupliacte.includes(true);
  //   let isDescriptionEqual =
  //     formValues.description === localStorage.getItem("description");
  //   if (finalResult && isDescriptionEqual) {
  //     setErrorMessage("Area already exists");
  //   } else {
  //     handleSubmit();
  //   }
  // };

  const handleSubmit = async () => {
    try {
      const url = ADD_EDIT_AREA_MASTER.replace(
        "{locationId}",
        locationId
      ).replace("{tenantId}", tenantId);
      let resp;
      if (!formValues.id) {
        resp = await post(url, formValues);
      } else {
        resp = await Put(url, formValues);
      }
      if (resp && resp?.id) {
        handleClear();
        handleClose();
        getAreas();
        toast.success(
          `Area ${formValues.id ? "updated" : "saved"} successfully`
        );
      } else if (resp?.id == null) {
        toast.error("Area already exists");
      }
    } catch (err) {
      if (err.response && err?.response.data)
        setErrorMessage(err.response.data.message);
      console.log(err);
    }
  };

  // GATE MASTER STATUS INACTIVE
  const statusInactive = async (id) => {
    try {
      const resp = await axios({
        method: "DELETE",
        url: `${INACTIVE_AREA_MASTER.replace("{locationId}", locationId)
          .replace("{tenantId}", tenantId)
          .replace("{id}", id)}`,
      }).then((res) => {
        getAreas();
        return res;
      });
      return resp;
    } catch (err) {
      return err;
    }
  };

  // GATE MASTER STATUS ACTIVE
  const statusActive = async (id) => {
    try {
      const resp = await axios({
        method: "DELETE",
        url: `${ACTIVE_AREA_MASTER.replace("{locationId}", locationId)
          .replace("{tenantId}", tenantId)
          .replace("{id}", id)}`,
      }).then((res) => {
        getAreas();
        return res;
      });
      return resp;
    } catch (err) {
      return err;
    }
  };

  /*eslint-disable */
  useEffect(() => {
    getAreas();
  }, []);
  /*eslint-enable */

  return {
    open,
    columns,
    loading,
    formValues,
    isDisabled,
    errorMessage,
    rows,
    setOpen,
    handleClose,
    handleOpenForm,
    findDuplicateArea: handleSubmit,
    handleInputChange,
    handleSearchChange,
  };
}
